export default __webpack_public_path__ + "static/media/right-chevron.7a292564.svg";